import React from "react";

/**
 * The ErrorBoundary is like a try-catch block for React components. We can use it anywhere in the component tree to catch errors and display a fallback UI.
 */
export class ErrorBoundary extends React.Component {
  override state: { hasError: boolean };
  constructor(props: object) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    // Update state so the next render will show the fallback UI.
    console.log("error in getDerivedStateFromError", error);
    return { hasError: true };
  }

  override componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo);
  }

  override render() {
    if (this.state.hasError) {
      return (
        <div>
          <h1>Something went wrong.</h1>
          <p>
            Try refreshing the page. If it doesn't fix the issue, contact us for
            support at hello@dots.community!
          </p>
        </div>
      );
    }

    return this.props.children;
  }
}
